'use client';

import Image from 'next/image';
import Link from 'next/link';

interface LogoMarkProps {
  size?: number;
  mono?: boolean;
  href?: string;
}

export function LogoMark({ size = 96, mono = false, href = '/' }: LogoMarkProps) {
  const src = mono ? '/fce-logo-white.png' : '/fce-logo.png';
  return (
    <Link
      href={href}
      aria-label="Biblioteca Digital FCE"
      style={{ display: 'inline-flex', alignItems: 'center', textDecoration: 'none' }}
    >
      <Image
        src={src}
        alt="Biblioteca Digital FCE"
        width={size}
        height={size}
        priority
        style={{ width: size, height: size, display: 'block', objectFit: 'contain' }}
      />
    </Link>
  );
}
